var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesStandard1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "232.4px",
    height: "302px",
    viewBox: "0 0 232.4 302",
    enableBackground: "new 0 0 232.4 302",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 37.6,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7568,
    strokeMiterlimit: 10,
    width: 198.4,
    height: 226.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 51.8,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7321,
    strokeMiterlimit: 10,
    width: 170.1,
    height: 198.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9086,
    strokeMiterlimit: 10,
    d: "M35.3,203.5c0,0-0.8,0.3-0.9,1.3 s-0.2,4.5-0.2,4.5s-0.1,1.1,1.1,1.5c1.2,0.4,7.6,1.9,9.6,2.4c2,0.5,15,3.9,18.5,4.5c3.5,0.6,18.6,3.3,21.7,3.8 c3.1,0.4,26,2.8,30.5,3c4.5,0.2,10-0.1,13.1,0s13.2-1.5,19.7-2c3.3-0.3,12-1.8,13.8-2.2c1.5-0.4,23.8-6.2,24.9-6.6 s9.8-2.9,10.3-3.1c0.6-0.2,1-0.4,1.2-1.6c0.2-1.2,0.1-3.5,0.1-3.5s0.1-0.6-0.2-0.7s-1-0.5-1-0.5l-16.7,4.4l-21.7,4.1l-16.6,3.8 l-22.6,1.1l-34-3.8l-32.8-6.1l-17.4-4.7L35.3,203.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9086,
    strokeMiterlimit: 10,
    d: "M35.7,196.1c0,0-1.2,0.6-1.2,1.6 c0,1,0,4.3,0,4.3s-0.4,0.9,0.7,1.2s7.9,2.6,9.6,3s20,4.4,23.9,5.3c4,0.9,27.6,4.6,33.4,5c5.9,0.4,23.4,1.7,23.4,1.7 s16.2-1.2,20.1-1.6s18.7-4,22.3-4.7s23.6-5.4,26.5-6.2c2.9-0.8,3.7-1.2,3.7-1.2s0.9,0,1-2c0-2,0-3.7,0-3.7s-0.2-1.3-1.2-1.4 c-1-0.1-1-0.5-1-0.5l-10.7,2.9l-31.4,7.8l-22.7,3.3l-11.7-0.3l-15.5-0.5l-19.6-2.6l-26.8-5.3l-19-5.7l-3.3-1L35.7,196.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9086,
    strokeMiterlimit: 10,
    d: "M35.6,187.8c0,0-1.4,0.6-1.4,2.5 s0,3.2,0,3.2s-0.3,1.4,1.4,2.1c1.7,0.8,11.6,4.1,13.9,4.7c2.3,0.6,28.9,7.2,35.1,8c6.1,0.8,30.4,3.5,43.3,3.2 c12.9-0.3,28.3-3.4,30.8-3.7s15.3-3.9,17.3-4.3c2.1-0.5,20.6-6.1,21.9-6.5c1.3-0.4,1.3-0.6,1.2-2.5s0.1-3.4-0.6-4.5 c-0.8-1.1-1.5-1.4-1.5-1.4l-0.9-0.8l-35.1,8.7l-18.6,3.4l-20.3,1l-17.7-1.6l-24.4-3.8L36.5,187L35.6,187.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9086,
    strokeMiterlimit: 10,
    d: "M35.1,53.8H197v110.3c0,0,2.1,8.3,2.1,12.9 s0,7.9,0,7.9s0.7,2.5-3.1,3.5c-3.8,1-15,4.5-23.8,6.4c-12.8,2.8-28.6,6-34.1,6.3c-5.5,0.3-14.8,1.1-26.4,0 c-11.6-1.1-44.5-6.3-50.7-7.7c-6.2-1.3-23.4-5.7-25-6.1c-1.7-0.5-2.8-1.2-2.2-6.4c0.6-5.3,1.6-11.3,1.6-14.1S35.1,53.8,35.1,53.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesStandard1);
export default __webpack_public_path__ + "static/media/FeaturesStandard1.4be750a6ae816a0734740fe9a3394951.svg";
export { ForwardRef as ReactComponent };